import React, { useMemo, useState, useCallback, useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import { AssetInnerTable, AccountRow, CallToActionRow } from 'atoms/AssetsTable'
import { useModal } from 'components/modals'
import { useFinances } from 'hooks/useFinances'

const dollarFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})

export default function TSPLoanAssets({ demoMode = false }) {
  const { openModal } = useModal()
  const { getAccounts } = useFinances()
  const [tspLoans, setTspLoans] = useState([])

  const storeTspLoans = useCallback(async () => {
    const accounts = await getAccounts()
    setTspLoans((accounts || []).filter(({ subType }) => subType === 'tspLoan'))
  }, [getAccounts])

  useEffect(() => {
    storeTspLoans()
  }, [storeTspLoans])

  const totalLoanAmount = useMemo(
    () => tspLoans.reduce((sum, loan) => sum + (loan.amount || 0), 0),
    [tspLoans]
  )

  const rows = useMemo(() => {
    if (!tspLoans || tspLoans.length === 0) {
      return [
        <CallToActionRow
          key="noLoans"
          text="Add your first TSP Loan"
          onClick={() =>
            !demoMode &&
            openModal('addAccounts', {
              getAccounts: storeTspLoans,
              openToPage: 'TSP',
            })
          }
        />,
      ]
    }

    return tspLoans.map((loan, index) => (
      <AccountRow
        key={loan.id || index}
        name={loan.name || `TSP Loan ${index + 1}`}
        amount={loan.amount || 0}
        subType={loan.subType}
        onClick={() =>
          !demoMode &&
          openModal('editAccount', {
            accountType: 'Liability',
            account: loan,
            getAccounts: storeTspLoans,
          })
        }
      />
    ))
  }, [tspLoans, demoMode, openModal, storeTspLoans])

  return (
    <>
      <Box
        mt={4}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="body1Medium" color="#262627">
          Total TSP Loans:
        </Typography>
        <Typography variant="body1Medium" mr={5} color="#262627">
          {dollarFormat.format(totalLoanAmount)}
        </Typography>
      </Box>

      <AssetInnerTable
        rows={rows}
        addAccountRow="Add a TSP Loan"
        openModal={openModal}
        openToPage="TSP Loans"
        onAddClick={() =>
          !demoMode &&
          openModal('addAccounts', {
            getAccounts: storeTspLoans,
            openToPage: 'TSP',
          })
        }
      />
    </>
  )
}
